module.exports = __webpack_public_path__ + "img/shenhe.2fc381c9.png";